import {Directive, HostListener, inject, Input} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Directive({
  selector: '[appFocusNextId]'
})
export class AppFocusNextIdDirective {

  document = inject(DOCUMENT)

  @Input('appFocusNextId')
  targetId: string;

  @HostListener('keyup.enter', ['$event'])
  onEnter(event: any) {

    if (!this.targetId) {
      event.target.blur();
    } else {
      const targetElement = this.document.getElementById(this.targetId);
      if (targetElement) {
        event.preventDefault();
        targetElement.focus();
      } else {
        event.target.blur();
      }
    }
  }
}
